import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import * as AdaptiveCards from 'adaptivecards';

@Component({
    selector: 'mapp-data-sources-documents',
    templateUrl: './data-sources-documents.component.html',
    styleUrls: ['./data-sources-documents.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DataSourcesDocumentsComponent implements AfterViewInit {
    @Input() sourceData: any;

    @ViewChild('accordionRef', { static: false }) accordionRef: ElementRef;

    /**
     *
     */
    ngAfterViewInit(): void {
        const card = {
            type: 'AdaptiveCard',
            body: [
                {
                    type: 'TextBlock',
                    text: 'Data Sources',
                    size: 'large',
                    weight: 'bolder',
                    style: 'heading',
                    wrap: true,
                    color: 'Accent',
                },
                {
                    type: 'Container',
                    id: 'container-data-source-document',
                    items: [
                        {
                            type: 'ColumnSet',
                            columns: [
                                {
                                    type: 'Column',
                                    items: [
                                        {
                                            type: 'Image',
                                            style: 'Person',
                                            url: `../../../assets/icons/${this.sourceData[0].document_meta.DocIcon}.svg`,
                                            size: 'Small',
                                        },
                                    ],
                                    width: '32px',
                                },
                                {
                                    type: 'Column',
                                    id: 'column-title',
                                    items: [
                                        {
                                            type: 'ActionSet',
                                            actions: [
                                                {
                                                    type: 'Action.OpenUrl',
                                                    title: `${this.sourceData[0].name}`,
                                                    url: `${this.sourceData[0].web_url}`,
                                                },
                                            ],
                                        },
                                        {
                                            type: 'TextBlock',
                                            spacing: 'None',
                                            text: `Created {{DATE(${this.sourceData[0].document_meta.Created},SHORT)}} Last Modified {{DATE(${this.sourceData[0].document_meta.Modified},SHORT)}}`,
                                            isSubtle: true,
                                            wrap: true,
                                        },
                                    ],
                                    width: 'auto',
                                },
                                {
                                    type: 'Column',
                                    id: 'column-label',
                                    items: [
                                        {
                                            type: 'TextBlock',
                                            text: `${this.sourceData[0].document_meta.Disclaimer.Label}`,
                                            wrap: true,
                                            size: 'Medium',
                                        },
                                    ],
                                    width: '198px',
                                    rtl: true,
                                    spacing: 'Padding',
                                },

                                {
                                    type: 'Column',
                                    id: 'toggle-column',
                                    spacing: 'Small',
                                    verticalContentAlignment: 'Top',
                                    items: [
                                        {
                                            type: 'Image',
                                            id: 'chevronDown1',
                                            url: '../../../assets/thumbs-down.svg',
                                            width: '20px',
                                            altText: 'Air Travel Expense $300 collapsed',
                                        },
                                        {
                                            type: 'Image',
                                            id: 'chevronUp1',
                                            isVisible: false,
                                            url: '../../../assets/thumbs-up.svg',
                                            width: '20px',
                                            altText: 'Air Travel Expense $300 expanded',
                                        },
                                    ],
                                    selectAction: {
                                        type: 'Action.ToggleVisibility',
                                        targetElements: [
                                            'cardContent1',
                                            'chevronUp1',
                                            'chevronDown1',
                                        ],
                                    },
                                    width: '32px',
                                    rtl: true,
                                },
                            ],
                        },
                        {
                            type: 'Container',
                            id: 'cardContent1',
                            isVisible: false,
                            items: [
                                {
                                    type: 'ColumnSet',
                                    columns: [
                                        {
                                            type: 'Column',
                                            items: [],
                                            width: '32px',
                                        },
                                        {
                                            type: 'Column',
                                            items: [
                                                {
                                                    type: 'Container',
                                                    items: [
                                                        {
                                                            type: 'TextBlock',
                                                            text: `${this.sourceData[0].document_meta.ShortDescription}`,
                                                            isSubtle: true,
                                                            wrap: true,
                                                            spacing: 'Padding',
                                                        },
                                                        {
                                                            type: 'TextBlock',
                                                            spacing: 'Padding',
                                                            text: `Uploaded by ${this.sourceData[0].modified_by} Region: ${this.sourceData[0].document_meta.Region[0].Label}`,
                                                            isSubtle: true,
                                                            wrap: true,
                                                        },
                                                    ],
                                                },
                                            ],
                                            width: 'auto',
                                        },
                                        {
                                            type: 'Column',
                                            items: [],
                                            width: '150px',
                                        },
                                        {
                                            type: 'Column',
                                            id: 'columnEmpty',
                                            spacing: 'Small',
                                            verticalContentAlignment: 'Center',
                                            items: [],
                                            width: '32px',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    separator: true,
                    spacing: 'default',
                    style: 'accent',
                },

                {
                    type: 'Container',
                    id: 'container-data-source-document',
                    items: [
                        {
                            type: 'ColumnSet',
                            columns: [
                                {
                                    type: 'Column',
                                    items: [
                                        {
                                            type: 'Image',
                                            style: 'Person',
                                            url: `../../../assets/icons/${this.sourceData[1].document_meta.DocIcon}.svg`,
                                            size: 'Small',
                                        },
                                    ],
                                    width: '32px',
                                },
                                {
                                    type: 'Column',
                                    id: 'column-title',
                                    items: [
                                        {
                                            type: 'ActionSet',
                                            actions: [
                                                {
                                                    type: 'Action.OpenUrl',
                                                    title: `${this.sourceData[1].name}`,
                                                    url: `${this.sourceData[1].web_url}`,
                                                },
                                            ],
                                        },
                                        {
                                            type: 'TextBlock',
                                            spacing: 'None',
                                            text: `Created {{DATE(${this.sourceData[1].document_meta.Created},SHORT)}} Last Modified {{DATE(${this.sourceData[1].document_meta.Modified},SHORT)}}`,
                                            isSubtle: true,
                                            wrap: true,
                                        },
                                    ],
                                    width: 'auto',
                                },
                                {
                                    type: 'Column',
                                    id: 'column-label',
                                    items: [
                                        {
                                            type: 'TextBlock',
                                            text: `${this.sourceData[1].document_meta.Disclaimer.Label}`,
                                            wrap: true,
                                            size: 'Medium',
                                        },
                                    ],
                                    width: '150px',
                                    rtl: true,
                                    spacing: 'Padding',
                                },

                                {
                                    type: 'Column',
                                    id: 'toggle-column',
                                    spacing: 'Small',
                                    verticalContentAlignment: 'Top',
                                    items: [
                                        {
                                            type: 'Image',
                                            id: 'chevronDown2',
                                            url: '../../../assets/arrow-down.svg',
                                            width: '20px',
                                            altText: 'Air Travel Expense $300 collapsed',
                                        },
                                        {
                                            type: 'Image',
                                            id: 'chevronUp2',
                                            isVisible: false,
                                            url: '../../../assets/arrow-up.svg',
                                            width: '20px',
                                            altText: 'Air Travel Expense $300 expanded',
                                        },
                                    ],
                                    selectAction: {
                                        type: 'Action.ToggleVisibility',
                                        targetElements: [
                                            'cardContent2',
                                            'chevronUp2',
                                            'chevronDown2',
                                        ],
                                    },
                                    width: '32px',
                                    rtl: true,
                                },
                            ],
                        },
                        {
                            type: 'Container',
                            id: 'cardContent2',
                            isVisible: false,
                            items: [
                                {
                                    type: 'ColumnSet',
                                    columns: [
                                        {
                                            type: 'Column',
                                            items: [],
                                            width: '32px',
                                        },
                                        {
                                            type: 'Column',
                                            items: [
                                                {
                                                    type: 'Container',
                                                    items: [
                                                        {
                                                            type: 'TextBlock',
                                                            text: `${this.sourceData[1].document_meta.ShortDescription}`,
                                                            isSubtle: true,
                                                            wrap: true,
                                                            spacing: 'Padding',
                                                        },
                                                        {
                                                            type: 'TextBlock',
                                                            spacing: 'Padding',
                                                            text: `Uploaded by ${this.sourceData[1].modified_by} Region: ${this.sourceData[1].document_meta.Region[0].Label}`,
                                                            isSubtle: true,
                                                            wrap: true,
                                                        },
                                                    ],
                                                },
                                            ],
                                            width: 'auto',
                                        },
                                        {
                                            type: 'Column',
                                            items: [],
                                            width: '150px',
                                        },
                                        {
                                            type: 'Column',
                                            id: 'columnEmpty',
                                            spacing: 'Small',
                                            verticalContentAlignment: 'Center',
                                            items: [],
                                            width: '32px',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    separator: true,
                    spacing: 'default',
                    style: 'accent',
                },
            ],
            $schema: 'https://adaptivecards.io/schemas/adaptive-card.json',
            version: '1.6',
            minHeight: '150px',
            verticalContentAlignment: 'Top',
            rtl: false,
        };

        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        // Set its hostConfig property unless you want to use the default Host Config
        // Host Config defines the style and behavior of a card
        adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({
            spacing: {
                small: 5,
                default: 10,
                medium: 20,
                large: 30,
                extraLarge: 40,
                padding: 10,
            },
            separator: {
                lineThickness: 1,
                lineColor: '#ffffff',
            },
            supportsInteractivity: true,
            fontTypes: {
                default: {
                    fontFamily: "'NotoSans-Regular','Helvetica Neue', sans-serif",
                    fontSizes: {
                        small: 12,
                        default: 14,
                        medium: 17,
                        large: 21,
                        extraLarge: 26,
                    },
                    fontWeights: {
                        lighter: 200,
                        default: 400,
                        bolder: 600,
                    },
                },
                monospace: {
                    fontFamily: "'NotoSans-Regular','Helvetica Neue', sans-serif",
                    fontSizes: {
                        small: 12,
                        default: 14,
                        medium: 17,
                        large: 21,
                        extraLarge: 26,
                    },
                    fontWeights: {
                        lighter: 200,
                        default: 400,
                        bolder: 600,
                    },
                },
            },
            containerStyles: {
                default: {
                    backgroundColor: '#FFFFFF',
                    foregroundColors: {
                        default: {
                            default: '#000000',
                            subtle: '#767676',
                        },
                        accent: {
                            default: '#002C77',
                            subtle: '#0063B1',
                        },
                        attention: {
                            default: '#FF0000',
                            subtle: '#DDFF0000',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#c3ab23',
                            subtle: '#DDc3ab23',
                        },
                    },
                },
                emphasis: {
                    backgroundColor: '#F0F0F0',
                    foregroundColors: {
                        default: {
                            default: '#000000',
                            subtle: '#767676',
                        },
                        accent: {
                            default: '#2E89FC',
                            subtle: '#882E89FC',
                        },
                        attention: {
                            default: '#FF0000',
                            subtle: '#DDFF0000',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#c3ab23',
                            subtle: '#DDc3ab23',
                        },
                    },
                },
                accent: {
                    backgroundColor: '#F4F4F4',
                    foregroundColors: {
                        default: {
                            default: '#333333',
                            subtle: '#EE333333',
                        },
                        dark: {
                            default: '#000000',
                            subtle: '#66000000',
                        },
                        light: {
                            default: '#FFFFFF',
                            subtle: '#33000000',
                        },
                        accent: {
                            default: '#2E89FC',
                            subtle: '#882E89FC',
                        },
                        attention: {
                            default: '#cc3300',
                            subtle: '#DDcc3300',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#e69500',
                            subtle: '#DDe69500',
                        },
                    },
                },
                good: {
                    backgroundColor: '#CCFFCC',
                    foregroundColors: {
                        default: {
                            default: '#333333',
                            subtle: '#EE333333',
                        },
                        dark: {
                            default: '#000000',
                            subtle: '#66000000',
                        },
                        light: {
                            default: '#FFFFFF',
                            subtle: '#33000000',
                        },
                        accent: {
                            default: '#2E89FC',
                            subtle: '#882E89FC',
                        },
                        attention: {
                            default: '#cc3300',
                            subtle: '#DDcc3300',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#e69500',
                            subtle: '#DDe69500',
                        },
                    },
                },
                attention: {
                    backgroundColor: '#FFC5B2',
                    foregroundColors: {
                        default: {
                            default: '#333333',
                            subtle: '#EE333333',
                        },
                        dark: {
                            default: '#000000',
                            subtle: '#66000000',
                        },
                        light: {
                            default: '#FFFFFF',
                            subtle: '#33000000',
                        },
                        accent: {
                            default: '#2E89FC',
                            subtle: '#882E89FC',
                        },
                        attention: {
                            default: '#cc3300',
                            subtle: '#DDcc3300',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#e69500',
                            subtle: '#DDe69500',
                        },
                    },
                },
                warning: {
                    backgroundColor: '#FFE2B2',
                    foregroundColors: {
                        default: {
                            default: '#333333',
                            subtle: '#EE333333',
                        },
                        dark: {
                            default: '#000000',
                            subtle: '#66000000',
                        },
                        light: {
                            default: '#FFFFFF',
                            subtle: '#33000000',
                        },
                        accent: {
                            default: '#2E89FC',
                            subtle: '#882E89FC',
                        },
                        attention: {
                            default: '#cc3300',
                            subtle: '#DDcc3300',
                        },
                        good: {
                            default: '#54a254',
                            subtle: '#DD54a254',
                        },
                        warning: {
                            default: '#e69500',
                            subtle: '#DDe69500',
                        },
                    },
                },
            },
            imageSizes: {
                small: 40,
                medium: 80,
                large: 160,
            },
            actions: {
                maxActions: 5,
                spacing: 'default',
                buttonSpacing: 8,
                showCard: {
                    actionMode: 'inline',
                    inlineTopMargin: 8,
                },
                actionsOrientation: 'horizontal',
                actionAlignment: 'stretch',
            },
            adaptiveCard: {
                allowCustomStyle: false,
            },
            imageSet: {
                imageSize: 'medium',
                maxImageHeight: 100,
            },
            factSet: {
                title: {
                    color: 'default',
                    size: 'default',
                    isSubtle: false,
                    weight: 'bolder',
                    wrap: true,
                    maxWidth: 150,
                },
                value: {
                    color: 'default',
                    size: 'default',
                    isSubtle: false,
                    weight: 'default',
                    wrap: true,
                },
                spacing: 8,
            },
        });
        adaptiveCard.onExecuteAction = function (action: any) {
            const { url } = action;
            if (action._propertyBag?.type === 'Action.OpenUrl') {
                window.open(url, '_blank');
            }
        };
        // Parse the card payload
        adaptiveCard.parse(card);

        // Render the card to an HTML element:
        const renderedCard = adaptiveCard.render();

        if (this.accordionRef) {
            const element = this.accordionRef.nativeElement;
            element.appendChild(renderedCard);
        }
    }

    // Create an AdaptiveCard instance

    /**
     *
     * @param index
     * @param item
     */
    trackBySourceData(index, item) {
        return item.name;
    }
}
